import styled from 'styled-components'
import { COLORS } from 'utils'

export interface CardStyles {
  marginLeft?: string
  marginRight?: string
  marginBottom?: string
  marginTop?: string
  padding?: string
  boxShadow?: string
  isHide?: boolean
  backgroundColor?: string
  borderRadius?: string
  minHeight?: string
  maxHeight?: string
}

export const Card = styled.div<CardStyles>`
  display: flex;
  flex-direction: column;
  margin-left: ${({ marginLeft }) => marginLeft ?? 0};
  margin-right: ${({ marginRight }) => marginRight ?? 0};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 0};
  margin-top: ${({ marginTop }) => marginTop ?? 0};
  padding: ${({ padding }) => padding};
  box-shadow: ${({ boxShadow }) => boxShadow};
  display: ${({ isHide }) => isHide && 'none'};
  background-color: ${({ backgroundColor }) => backgroundColor || COLORS.white};
  border-radius: ${({ borderRadius }) => borderRadius};
  min-height: ${({ minHeight }) => minHeight && minHeight};
  max-height: ${({ maxHeight }) => maxHeight && maxHeight};
`
